import { TextField } from "@mui/material";
import React from "react";
import { NumericFormat } from "react-number-format";

const MoneyInputWithBlur = ({ label, value, onChange, onBlur }) => {
    const handleFocus = (event) => {
        // Se o valor é 0, limpar o campo quando ganhar foco
        if (value === 0 || value === "" || value === null || value === undefined) {
            onChange({ value: "" });
        }
    };

    return (
        <NumericFormat
            label={label}
            fullWidth
            customInput={TextField}
            value={value}
            onValueChange={onChange}
            onBlur={onBlur}
            onFocus={handleFocus}
            thousandSeparator="."
            decimalSeparator=","
            prefix="R$ "
            decimalScale={2}
            fixedDecimalScale
            inputMode="decimal"
            inputProps={{
                inputMode: "decimal"
            }}
        />
    )
}

export default MoneyInputWithBlur